<template>
    <div class="clearfix npagePage product">
        <div class="pde">
            <div class="carousel-inner">
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/58Dimg_01.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/58Dimg_02.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/58Dimg_03.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/58Dimg_04.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/58Dimg_05.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/58Dimg_06.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/58Dimg_07.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/58Dimg_08.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/58Dimg_09.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/58Dimg_10.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/58Dimg_11.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/58Dimg_12.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/58Dimg_13.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/58Dimg_14.jpg" />
                </div>
                <div class="pimg wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <img src="/static/img/58Dimg_15.jpg" />
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    data() { return {} }

}
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// ac1.vue?003a70ea